import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Toast from '../components/Toast';
import { ProductsProvider } from '../context/ProductsContext';
import styles from './AppLayout.module.css';

export default function AppLayout() {
  return (
    <ProductsProvider>
      <div className={styles.shell}>
        <Sidebar />
        <div className={styles.main}>
          <Topbar />
          <div className={styles.content}>
            <Outlet />
          </div>
        </div>
        <Toast />
      </div>
    </ProductsProvider>
  );
}
